export default "__VITE_PUBLIC_ASSET__9c36413d__"